import React from 'react';


export default class Restpause extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render(){
    const strings = this.state.strings;
    const video = '302447193';

    return(
      <div>
        <div>Exemplo de um exercício com 3 séries: Execute o exercício até a falha, espere os segundos propostos (10seg por exemplo) e, logo em seguida, volte a executar o exercício até a falha novamente (isso será UMA série). Repita isso nas 2 séries seguintes. Exemplo no final do vídeo.</div>
          <iframe
            className='vimeo-video'
            src={`https://player.vimeo.com/video/${video}?autoplay=1&loop=1&autopause=0`}
            height="300"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen="true">
          </iframe>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/Restpause.js